import { wpBaseURL } from '$lib/api';
import { withFeaturedMedia } from '$lib/utils';
import { error } from '@sveltejs/kit';
import type { WP_REST_API_Posts } from 'wp-types';
import { algoliarecommend } from '$lib/algolia-recommend';

// https://cheerio.js.org
// https://en.gravatar.com/site/implement/images/
// todo: fetch media?parent=id
// def: https://picsum.photos/seed/«uid»/64/64.webp

export async function load({ params: { slug, type }, setHeaders }) {
	const url = `${wpBaseURL}${type === 'cikk' ? 'posts' : 'pages'}?slug=${slug}&limit=1&_fields=content.rendered,title,date,modified,id,_links.wp:featuredmedia,_links.author,_embedded&_embed`;
	const response = await fetch(url);
	const post = ((await response.json()) as WP_REST_API_Posts)[0];
	if (!post) throw error(404);

	setHeaders({
		'Cache-Control': 'public, max-age=3600',
	});

	return {
		post: withFeaturedMedia(post),
		recommendedPosts: await algoliarecommend([{
			indexName: 'articles',
			objectID: String(post.id),
			maxRecommendations: 3,
			threshold: 20,
			fallbackParameters: {
				query: ''
			},
			model: 'related-products'
		}])
	};
}

export const prerender = 'auto'